export const FILE = {
  LABEL: {
    RENAME: "Nombre",
    FORMAT_UPLOAD_FILE:
      "El formato debe ser PNG, JPG, JPEG, XLS, PDF, DOC, MP4, MKV, AVI",
    DOCUMENT_INPUT: "Elección de documentos",
    UPLOAD_DOCUMENT: "Carga de documento",
    EDIT_DOCUMENT: "Editar categoria de documento",
    SHARE_DOCUMENT: "Compartir documentos",
    UPLOAD_CONFIRMATION_TITLE: "Confirmar documento",
    UPLOAD_CONFIRMATION_TEXT: "¿Está seguro que desea cargar este documento?",
    UPLOADED_DOCUMENT: "Documento cargado",
    CATEGORY: "Categoría",
    SUB_CATEGORY: "Sub categoría"
  },
  HINT: {
    RENAME: "Diligencia para cambiar el nombre con que se carga el documento"
  },
  BUTTON: {
    CANCEL: "Cancelar",
    UPLOAD: "Cargar",
    UPDATE: "Actualizar",
    DELETE: "Eliminar"
  },
  EVENT: {
    CANCEL: "cancel",
    UPLOAD: "uploadDocument",
    DELETE: "deleteDocument"
  },
  SNACKBAR: {
    RECORD_FAILED: "No se pudo crear registro de documento",
    UPLOAD_FAILED: "Hubo un error al cargar el documento",
    DELETE_FAILED: "No se pudo eliminar el registro correctamente",
    UPLOAD: "Documento guardado exitosamente"
  },
  FILE_STORAGE_FOLDER: "documents",
  APPLICATION_STORAGE_FOLDER: "application"
};

export const IMG_TYPE = {
  png: "image/png",
  jpg: "image/jpeg"
};

const VIDEO_TYPE = {
  mp4: ".mp4",
  mkv: ".mkv",
  avi: ".avi",
  mov: ".mov",
  wmv: ".wmv",
  flv: ".flv",
  webm: ".webm"
};

export const IMG_TYPE_EXTENSIONS = ["png", "jpg", "jpeg"];

export const VIDEO_TYPE_EXTENSIONS = [
  "mp4",
  ".mkv",
  ".avi",
  ".mov",
  ".wmv",
  ".flv",
  ".webm"
];

export const DOCUMENT_TYPE_EXTENSIONS = [
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "txt",
  "ppt",
  "pptx",
  "csv",
  "zip",
  "rar",
  "7z",
  "tar",
  "gz"
];

export const DOCUMENT_FILES = {
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xls: "application/vnd.ms-excel",
  pdf: ".pdf",
  doc: ".doc",
  docx: ".docx"
};

export const USER_DOCUMENTS_FORMAT = [
  IMG_TYPE.png,
  IMG_TYPE.jpg,
  DOCUMENT_FILES.xlsx,
  DOCUMENT_FILES.xls,
  DOCUMENT_FILES.pdf,
  DOCUMENT_FILES.doc,
  DOCUMENT_FILES.docx,
  VIDEO_TYPE.mp4,
  VIDEO_TYPE.mkv,
  VIDEO_TYPE.avi,
  VIDEO_TYPE.mov,
  VIDEO_TYPE.wmv,
  VIDEO_TYPE.flv,
  VIDEO_TYPE.webm
];
